import { AdminBookingFormDialog } from '~/ui/Dialogs/BookingFormDialog/AdminBookingForm';
import { MobileLogin } from '../Dialogs/MobileLogin/MobileLogin';
export default {
    book: {
        component: AdminBookingFormDialog,
        props: {
            showCloseButton: false,
        }
    },
    mobile_login: {
        component: MobileLogin,
        props: {
            type: "extra-small"
        }
    },
};